import React from "react";
import MGrid from '@mui/material/Grid';

const Grid = ({children, ...props}) =>{
    return <MGrid {...props}>{children}</MGrid>
}

export default React.memo(Grid);